export default __webpack_public_path__ + "static/media/footer-waves.3930306b.svg";